import { normalizeChartCandles } from './normalizeChartCandles';

function maxNumber(left, right) {
  if (left == null) return right ?? null;
  if (right == null) return left ?? null;
  return Math.max(Number(left), Number(right));
}

function minNumber(left, right) {
  if (left == null) return right ?? null;
  if (right == null) return left ?? null;
  return Math.min(Number(left), Number(right));
}

export function normalizeLiveCandleToChartBucket({
  liveCandle,
  timeUnit,
  candleDuration,
  sessionWindows = [],
}) {
  const [normalized] = normalizeChartCandles({
    candles: [liveCandle],
    timeUnit,
    candleDuration,
    sessionWindows,
  });

  if (!normalized) {
    return null;
  }

  return {
    ...normalized,
    liveSourceTimeStamp:
      liveCandle?.timeStamp == null ? null : Number(liveCandle.timeStamp),
  };
}

export function mergeLiveCandleIntoCurrent({
  currentCandle,
  normalizedLiveCandle,
}) {
  if (!normalizedLiveCandle) {
    return currentCandle ?? null;
  }

  if (!currentCandle) {
    return normalizedLiveCandle;
  }

  return {
    ...currentCandle,
    ...normalizedLiveCandle,
    open: currentCandle.open ?? normalizedLiveCandle.open,
    high: maxNumber(currentCandle.high, normalizedLiveCandle.high),
    low: minNumber(currentCandle.low, normalizedLiveCandle.low),
    close: normalizedLiveCandle.close ?? currentCandle.close,
    slotIndex: currentCandle.slotIndex,
  };
}
